(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:theme
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('theme', {
      'name': 'security'
    });
}());
